// removed by extract-text-webpack-plugin
module.exports = {"sectionContainer":"sectionContainer","sectionContainer__date":"sectionContainer__date","sectionContainer__date__text":"sectionContainer__date__text","sectionContainer__text":"sectionContainer__text","isTablet":"isTablet","sectionContainer__date__img":"sectionContainer__date__img"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Instructions/Section/section.scss
// module id = 569
// module chunks = 0